import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import styles from './Sidebar.module.css';
import logoLightVertical from "../../assets/img/logo-light-vertical.png";
import {
  Dashboard,
  PhonelinkSetup, // Para Registros de Pesca
  People,        // Para Pescadores
  Assignment,    // Para Projetos
  WhatsApp,               // Para Mensagens
  AccountBalance, // Para Colônias
  Phishing,      // para Artes
  SetMeal,   // para Espécies
  ManageAccounts, // para Usuários
  Description, // para Templates
  SmartToy, // para Laboratório de Interação
  PhotoLibrary, // para Galeria
  Public, // para Geografia
} from "@mui/icons-material";

const Sidebar = () => {
  const isAdmin = localStorage.getItem('modulo') === 'admin';
  const location = useLocation();

  const menuItems = [
    { name: 'Dashboard', path: '/admin/dashboard', icon: <Dashboard /> },
    { name: 'Pescadores', path: '/admin/pescadores', icon: <People /> },
    { name: 'Registros de Pesca', path: '/admin/registros', icon: <PhonelinkSetup /> },
    // "Geografia" reúne Mapa de Pesca, Locais de Pesca, Pendências de
    // Local e Áreas de Pesca numa casca só com abas (GeografiaLayout) — 4
    // itens de sidebar viraram 1. As 4 telas não compartilham um prefixo
    // de URL comum (/admin/locais/* e /admin/areas são caminhos
    // separados), então usa matchPrefixes em vez do `end`/isActive comum
    // do NavLink pra esse item ficar selecionado em qualquer uma das 4.
    { name: 'Geografia', path: '/admin/locais/mapa', icon: <Public />, matchPrefixes: ['/admin/locais', '/admin/areas'] },
    { name: 'Mensagens', path: '/admin/mensagens', icon: <WhatsApp /> },
    { name: 'Laboratório de Interação', path: '/admin/chat-syncorp', icon: <SmartToy /> },
    { name: 'Galeria', path: '/admin/galeria', icon: <PhotoLibrary /> },
    { name: 'Projetos', path: '/admin/projetos', icon: <Assignment /> },
    ...(isAdmin ? [{ name: 'Usuários', path: '/admin/usuarios', icon: <ManageAccounts /> }] : []),
    ...(isAdmin ? [{ name: 'Templates', path: '/admin/templates', icon: <Description /> }] : []),
    { name: 'Colônias', path: '/admin/colonias', icon: <AccountBalance /> },
    { name: 'Espécies', path: '/admin/especies', icon: <SetMeal /> },
    { name: 'Artes de Pesca', path: '/admin/artes', icon: <Phishing /> },
  ];

  return (
    <aside className={styles.containerMenuSide}>
      {/* SEÇÃO DO LOGO */}
      <div className={styles.logoContainer}>
        <img
          src={logoLightVertical}
          alt="Syncorp Logo"
          className={styles.logoImg}
        />
      </div>

      <div className={styles.MenuSideItens}>
        {menuItems.map((item) => {
          const matchPrefixes = (item as { matchPrefixes?: string[] }).matchPrefixes;
          const selecionadoPorPrefixo = matchPrefixes?.some((p) => location.pathname.startsWith(p));
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                (isActive || selecionadoPorPrefixo) ? `${styles.MenuSideItem} ${styles.selected}` : styles.MenuSideItem
              }
            >
              <div className={styles.MenuSideHidden}>
                <div className={styles.MenuSideItemImg}>{item.icon}</div>
                <p>{item.name}</p>
              </div>
            </NavLink>
          );
        })}
      </div>
    </aside>
  );
};

export default Sidebar;